// @flow
import * as React from 'react';
import { Text, RadioGroup, Radio } from 'informed';

import { PrimaryText } from '../../../Typography.jsx';
import { PrimaryButton } from '../../../Buttons.jsx';
import SimpleTable from '../../../SimpleTable.jsx';
import examItems from '../physicalExaminationItems';

import styles from '../../../../styles/patientPages/wellChildCheck/PhysicalExam.scss';

type Props = {
  physicalExamination: Object,
  setAllNormal: Function,
  resetAll: Function,
}

class EditPhysicalExamination extends React.Component<Props> {
  render() {
    const physicalExamination = examItems.map(
      (itemName, index) => ({
        itemName,
        ...this.props.physicalExamination[index],
      }),
    );

    const columns = [
      {
        Header: 'Item',
        id: 'itemName',
        accessor: 'itemName',
        width: 200,
      },
      {
        Header: 'Result',
        id: 'result',
        width: 200,
        Cell: item => (
          <RadioGroup
            field={`physicalExamination[${item.index}].normal`}
            initialValue={item.original.normal}
          >
            <span className={styles.radioButton}><Radio value={true} />Normal</span>
            <Radio value={false} />Abnormal
          </RadioGroup>
        ),
      },
      {
        Header: 'Abnormalities/Comments',
        id: 'comments',
        Cell: item => (
          <Text
            style={{ width: '90%' }}
            field={`physicalExamination[${item.index}].comments`}
            initialValue={item.original.comments}
          />
        ),
      },
    ];

    return (
      <div>
        <PrimaryText>Physical Examination</PrimaryText>
        <div>
          <PrimaryButton onClick={this.props.setAllNormal}>Set All Normal</PrimaryButton>
          <PrimaryButton onClick={this.props.resetAll}>Reset All Results</PrimaryButton>
        </div>
        <div className={styles.table}>
          <SimpleTable
            data={physicalExamination}
            columns={columns}
            style={{}} // override max height on default Table
          />
        </div>
      </div>
    );
  }
}

export default EditPhysicalExamination;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/wellChildCheck/edit/EditPhysicalExamination.jsx